<template>
    <outboxCon>
        <div class="product-solution">
            <app-title main='我们有全套产品解决方案' sub='适用于各种规模的机构'></app-title>
            <div class="production-solution-box">
                <div class="production-solution-item" v-for="(item, index) in solutionList" :key="`por-${index}`">
                    <div class="teach-box">
                        <img class="bg-img" :src="item.bg_img">
                        <img class="tea-img" :src="item.tea_img">
                    </div>
                    <div class="pro-info">
                        <p class="tip">{{item.img_des}}</p>
                        <p class="pro-title">{{item.type_name}}</p>
                        <p class="pro-des">{{item.type_des}}</p>
                        <button class="getMore" @click="knowMore(item.type_id)">了解更多</button>
                    </div>
                </div>
            </div>
            <button @click="openService" class="service-btn">专人服务</button>
        </div>
    </outboxCon>
</template>
<script>
import { productSolutionList } from '@/const/index'
export default {
  data () {
    return {
      solutionList: productSolutionList,
      routerPath: ['', '/production/ssLive', '/production/shuangshi', '/production/ai', '/production/content']
    }
  },
  methods: {
    openService () {
      this.$EventBus.$emit('open')
    },
    knowMore (id) {
      this.$router.push(this.routerPath[id])
    }
  }
}
</script>
<style lang="scss" scoped>
    .product-solution{
        width: $main-width;
        margin: 0 auto;
        padding: 100px 20px 99px;
        .production-solution-box{
            margin-top: 70px;
            display: flex;
            justify-content: center;
            align-content: flex-start;
            .production-solution-item{
                width: 264px;
                margin-right: 18px;
                transition: transform .5s;
                border-radius: 10px;
                .teacher-img{
                    width: 264px;
                    height: 214px;
                }
                .teach-box{
                    width: 264px;
                    height: 167px;
                    position: relative;
                    .bg-img{
                        width: 264px;
                        height: 167px;
                        position: absolute;
                        left: 0px;
                        bottom: 0px;
                    }
                    .tea-img{
                        width: 264px;
                        height: 213px;
                        position: absolute;
                        right: 0px;
                        bottom: 0px;
                    }
                }
                .pro-info{
                    position: relative;
                    padding: 36px 18px 20px;
                    text-align: left;
                    border:1px solid #eeeeee;
                    border-top: 0px;
                    border-radius:0px 0px 10px 10px;
                    .tip{
                        font-size:12px;
                        font-family:PingFangSC-Semibold;
                        font-weight:600;
                        line-height: 30px;
                        background: #ffffff;
                        border:1px solid rgba(206, 206, 206, 0.6);
                        box-shadow:0px 5px 5px 0px rgba(0, 0, 0, 0.03);
                        border-radius:15px;
                        padding: 0px 30px;
                        text-align: center;
                        position: absolute;
                        top: -16px;
                        right: 16px;
                    }
                    .pro-title{
                        font-family: PingFangSC-Semibold;
                        font-size: 22px;
                        line-height: 22px;
                    }
                    .pro-des{
                        height: 90px;
                        margin-top: 13px;
                        font-family: PingFangSC-Regular;
                        font-size: 16px;
                        line-height: 30px;
                    }
                    .getMore{
                        display: block;
                        margin: 18px auto 0px;
                        width:146px;
                        background:rgba(255,255,255,1);
                        border:1px solid rgba(206, 206, 206, 0.6);
                        box-shadow:0px 3px 3px 0px rgba(0, 0, 0, 0.03);
                        border-radius:5px;
                        line-height: 50px;
                        font-size:16px;
                        font-family:PingFang SC;
                        font-weight:400;
                        cursor: pointer;
                        &:hover{
                            color: #fb594a;
                        }
                        &:active{
                            background: rgba(0, 0, 0, 0.03);
                            color: #fb594a;
                        }
                    }
                }
                &:last-of-type{
                    margin-right: 0px;;
                }
                &:hover{
                    transform: scaleX(1.1) scaleY(1.1);
                    background: transparent;
                    box-shadow:0px 18px 29px 0px rgba(105,111,127,0.09);
                }
            }
        }
        .service-btn{
            margin: 96px auto 0px;
            width:416px;
            line-height:70px;
            background:#FB594A;
            border: 0;
            // box-shadow:0px 5px 5px 0px rgba(0, 0, 0, 0.1);
            border-radius:5px;
            font-size:24px;
            font-family:PingFang SC;
            font-weight:400;
            color:#ffffff;
            cursor: pointer;
            &:active{
                background: #f05648;
            }
        }
    }
</style>
